<template>
  <div>
    <div class="text-h6">
      Check your email inbox
    </div>
    <p>
      Enter the code that was emailed to you.
    </p>
    <form @submit.prevent="submitCode">
      <q-input v-model="code" outlined autofocus />
      <message v-if="result.error" type="negative" class="q-mt-md">
        {{ result.error }}
      </message>
      <div class="text-center q-my-md">
        <async-btn
          :task="task"
          type="submit"
          label="Continue"
          color="primary"
          class="full-width"
          rounded
        />
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import AsyncBtn from '@/components/AsyncBtn.vue';
import Message from '@/components/message/Message.vue';
import { submitEmailAuthCode, LoginResult } from '.';

interface Data {
  code: string,
  task: Promise<LoginResult>|null,
}

export default defineComponent({
  emits: ['error', 'result'],
  components: { Message, AsyncBtn },
  mixins: [HasTaskMixin],
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    result: {
      type: Object as () => LoginResult,
      required: true,
    },
  },
  data(): Data {
    return {
      code: '',
      task: null,
    };
  },
  methods: {
    submitCode() {
      this.task = submitEmailAuthCode(this.sessionId, this.code);
      this.task.then((result) => {
        this.$emit('result', result);
      });
      this.task.catch(() => {
        this.$emit('error');
      });
    },
  },
});
</script>
